export const calendly = "https://calendly.com/dalma-kennenlernen/15-min"

export const termsAndConditions = {
  name: "Terms & conditions",
  description: "IPID PDF - 211 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/Terms_and_conditions_Dalma_de.pdf",
}

export const IPID = {
  name: "IPID",
  description: "IPID PDF - 178 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/IPID_Dalma_de.pdf",
} as const

export const privacyAndCookiesPolicies = {
  name: "Policies Dalma",
  description: "IPID PDF - 178 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Policies_Dalma_de.pdf",
}

export const informationNotice = {
  name: "Information Notice Dalma",
  description: "Garantees PDF - 3.5 Mo",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/NI_Dalma_de.pdf",
}

export const Erstinformationen = {
  name: "Erstinformationen Dalma",
  description: "Erstinformationen PDF - 14.9Mo",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Erstinformation_Dalma_de.pdf",
}

const LEGAL_LINKS = {
  CGU: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Terms_and_conditions_Dalma_de.pdf",
  FIC: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/FIC_Dalma_de.pdf",
  PRIVACY_POLICY_URL:
    "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Policies_Dalma_de.pdf",
  IPID: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/IPID_Dalma_de.pdf",
  NI: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/NI_Dalma_de.pdf",
  Erstinformation: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Erstinformation_Dalma_de.pdf",
} as const

export function buildLegalURL(
  documentType: keyof typeof LEGAL_LINKS
) {
  return LEGAL_LINKS[documentType]
}

export const DE_APP_DOWNLOAD_URL = "https://dalma-de.onelink.me/cLht/9uutwvne"